import {
  getTenantCustomImage,
  getTenantName,
  isAuthGradientDomain,
  isSelectiveAiDomains,
  isUniversalLoginHost,
} from 'common/HelperFunctions'
import Logo from 'common/components/Logo'
import {BUILD_VERSION} from 'common/constants'
import {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {Link, Outlet} from 'react-router'
import {MainReducer, RootState} from 'setup'
import {getGeneralSettings} from 'setup/redux/Actions/General/settings'

import {toAbsoluteUrl} from '_metronic/helpers'

const AuthLayout = () => {
  const dispatch = useDispatch()
  const generalSettings = useSelector<RootState>(
    ({mainReducer}) => mainReducer.generalSettings
  ) as MainReducer['generalSettings']
  const generalSettingsLoaded = useSelector<RootState>(
    ({mainReducer}) => mainReducer.generalSettingsLoaded
  ) as boolean

  const defaultBackgroundUrl = toAbsoluteUrl('/media/background/6.png')
  const [backgroundUrl, setBackgroundUrl] = useState('')

  const initBackgroundImage = () => {
    const customBackgroundImage = getTenantCustomImage('background_image')
    if (customBackgroundImage) setBackgroundUrl(customBackgroundImage)
    else if (generalSettings.background_image) setBackgroundUrl(generalSettings.background_image)
    // Until the server answers, an empty setting means "not asked yet" — leave the
    // plain white ground rather than flashing the default at a branded tenant.
    else if (generalSettingsLoaded) setBackgroundUrl(defaultBackgroundUrl)
  }

  useEffect(() => {
    if (!isUniversalLoginHost()) {
      dispatch(getGeneralSettings())
    }
    initBackgroundImage()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    initBackgroundImage()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [generalSettings, generalSettingsLoaded])

  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, [])

  const isSpecialDomain = isAuthGradientDomain()

  return (
    <div
      className='d-flex flex-column flex-lg-row flex-column-fluid h-100 min-vh-100 position-relative'
      data-selective-ai-domain={isSelectiveAiDomains() ? 'true' : undefined}
      style={
        isSpecialDomain
          ? {
              background: 'linear-gradient(90.14deg, #431214 0.12%, #031C36 99.87%)',
            }
          : undefined
      }
    >
      {isSpecialDomain ? (
        <>
          <Link
            to='/auth/login'
            className='position-absolute top-0 start-0 p-10 z-index-1 d-flex align-items-center gap-2 text-white fw-bold fs-4 text-decoration-none'
          >
            <img
              src={toAbsoluteUrl('/media/auth/image 70.png')}
              alt='Logo'
              style={{maxHeight: '48px'}}
            />
            Timetable™
          </Link>
          {/* 'safe center': centred, but top-aligned once the card outgrows the viewport so nothing is pushed into unreachable overflow. */}
          <div
            className='d-flex flex-center flex-column flex-column-fluid w-100 p-10 pb-lg-20'
            style={{justifyContent: 'safe center'}}
          >
            <div
              className='w-100 mw-550px shadow-sm p-8 p-lg-12 mx-auto mt-0 mt-lg-20'
              style={{
                background: 'rgba(40, 40, 50, 0.85)',
                backdropFilter: 'blur(12px)',
                borderRadius: 32,
                boxShadow: '0px 2px 2px 0px #0000001A',
              }}
            >
              <Outlet />
            </div>
          </div>
          <div className='d-flex flex-center flex-column-auto p-10'>
            <div className='d-flex gap-5 fw-semibold fs-base text-white'>
              {getTenantName() !== 'lgs' && !!generalSettings?.powered_by_text && (
                <div dangerouslySetInnerHTML={{__html: generalSettings?.powered_by_text}} />
              )}
              <div>Build: {BUILD_VERSION}</div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className='d-flex flex-column flex-column-fluid flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1'>
            <div className='d-flex flex-center flex-column flex-column-fluid flex-lg-row-fluid'>
              <div className='w-100 mw-500px p-10 mx-auto'>
                <Outlet />
              </div>
            </div>

            {/* begin::Footer */}
            <div className='d-flex flex-center flex-wrap px-5'>
              <div className='d-flex gap-5 fw-semibold text-primary fs-base'>
                {getTenantName() !== 'lgs' && !!generalSettings?.powered_by_text && (
                  <div dangerouslySetInnerHTML={{__html: generalSettings?.powered_by_text}} />
                )}
                <div>Build: {BUILD_VERSION}</div>
              </div>
            </div>
          </div>

          {/* begin::Aside */}
          <div
            className='d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-2'
            style={{
              backgroundColor: '#fff',
              backgroundImage: backgroundUrl ? `url(${backgroundUrl})` : undefined,
            }}
          >
            {/* begin::Content */}
            <div className='d-flex flex-column flex-center py-15 px-5 px-md-15 w-100'>
              {/* begin::Logo */}
              <Link to='/' className='mb-12'>
                <Logo size='big' />
              </Link>
              {/* end::Logo */}

              {/* begin::Image */}
              {/* <img
            className='mx-auto w-275px w-md-50 w-xl-500px mb-10 mb-lg-20'
            src={toAbsoluteUrl('media/misc/auth-screens.png')}
            alt=''
          /> */}
              {/* end::Image */}

              {/* begin::Title */}
              {/* <h1 className='text-white fs-2qx fw-bolder text-center mb-7'>
            Fast, Efficient and Productive
          </h1> */}
              {/* end::Title */}

              {/* begin::Text */}
              {/* <div className='text-white fs-base text-center'>
            In this kind of post,{' '}
            <a href='#' className='opacity-75-hover text-warning fw-bold me-1'>
              the blogger
            </a>
            introduces a person they’ve interviewed <br /> and provides some background information
            about
            <a href='#' className='opacity-75-hover text-warning fw-bold me-1'>
              the interviewee
            </a>
            and their <br /> work following this is a transcript of the interview.
          </div> */}
              {/* end::Text */}
            </div>
            {/* end::Content */}
          </div>
          {/* end::Aside */}
        </>
      )}
    </div>
  )
}

export {AuthLayout}
